import { WebAuth } from 'auth0-js';
// This method is exported into its own module to enable mocking in unit tests.
export function createWebAuth(options) {
    return new WebAuth(options);
}
